import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function n(_x, _x2) {
  return _n.apply(this, arguments);
}

function _n() {
  _n = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, i) {
    var _yield$Promise$all, _yield$Promise$all2, e, o, s;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all([import('./dist-TF5BXIJN.js'), import('./dist-K62S3CAZ.js')]);

          case 2:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            e = _yield$Promise$all2[0].relottie;
            o = _yield$Promise$all2[1].default;
            _context.next = 8;
            return e().use(o, {
              lss: i
            }).process(JSON.stringify(t));

          case 8:
            s = _context.sent;
            return _context.abrupt("return", JSON.parse(s.value));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _n.apply(this, arguments);
}

export { n as a };